export default "__VITE_ASSET__CXmOknst__"